"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var React = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var INITIAL_STATE = {
    loading: true,
    isPortrait: true
};
var ArcadeGame = (function (_super) {
    __extends(ArcadeGame, _super);
    function ArcadeGame(props) {
        var _this = _super.call(this, props) || this;
        _this.orientationChange = function () {
            _this.setState({ isPortrait: window.screen.orientation.type.includes('portrait') });
        };
        _this.receiveMessagePBL = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var data, gameData, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 14, , 15]);
                        data = JSON.parse(event.data);
                        console.warn('***** poGame', data);
                        if (!data || data.type !== 'poGame')
                            return [2];
                        gameData = void 0;
                        if (this.props.isPBLGame) {
                            gameData = {
                                points: this.props.gamePoints,
                                outcome: this.props.gamePoints,
                                spinResults: this.props.spinResults ? this.props.spinResults : null,
                                gameFace: this.props.gameData ? this.props.gameData.face : null,
                                gameConfig: this.props.gameData ? this.props.gameData.gameConfig : null,
                                type: this.props.gameType ? this.props.gameType : 'prize',
                                topPrize: this.props.topPrize
                            };
                        }
                        else if (this.props.gameNGL) {
                            gameData = {
                                points: this.props.gameNGL.prizeInfo.totalPrizeAmount,
                                type: this.props.gameType ? this.props.gameType : 'prize',
                                wager: this.props.wager,
                                gameFace: this.props.gameNGL.outcome,
                                gameConfig: this.props.selectedNGLGame,
                                topPrize: this.props.topPrize
                            };
                        }
                        _a = data.name;
                        switch (_a) {
                            case 'onGameReplayHandler': return [3, 1];
                            case 'onGameStartHandler': return [3, 4];
                            case 'onGameReadyHandler': return [3, 5];
                            case 'onGameEndHandler': return [3, 6];
                            case 'onGameExitHandler': return [3, 9];
                        }
                        return [3, 12];
                    case 1:
                        if (!this.props.onGameReplayHandler) return [3, 3];
                        return [4, this.props.onGameReplayHandler()];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        if (data.data === null || data.data.reload === false) {
                            document.getElementById('arcade-game-container').contentWindow.postMessage(JSON.stringify({
                                type: 'poGameParent',
                                name: 'setGameConfig',
                                data: gameData
                            }), '*');
                        }
                        return [2, console.warn('***** onGameReplayHandler')];
                    case 4:
                        {
                            if (this.props.onGameStartHandler)
                                this.props.onGameStartHandler();
                            return [2, console.warn('***** onGameStartHandler')];
                        }
                        _c.label = 5;
                    case 5:
                        {
                            if (this.props.onGameReadyHandler)
                                this.props.onGameReadyHandler();
                            document.getElementById('arcade-game-container').contentWindow.postMessage(JSON.stringify({
                                type: 'poGameParent',
                                name: 'setGameConfig',
                                data: gameData
                            }), '*');
                            return [2, console.warn('***** onGameReadyHandler gameData:', gameData)];
                        }
                        _c.label = 6;
                    case 6:
                        if (!this.props.onGameEndHandler) return [3, 8];
                        return [4, this.props.onGameEndHandler()];
                    case 7:
                        _c.sent();
                        _c.label = 8;
                    case 8: return [2, console.warn('***** onGameEndHandler')];
                    case 9:
                        if (!this.props.onGameExitHandler) return [3, 11];
                        return [4, this.props.onGameExitHandler()];
                    case 10:
                        _c.sent();
                        _c.label = 11;
                    case 11:
                        this.props.onCloseGame();
                        return [2, console.warn('***** onGameExitHandler')];
                    case 12: return [2];
                    case 13: return [3, 15];
                    case 14:
                        _b = _c.sent();
                        return [3, 15];
                    case 15: return [2];
                }
            });
        }); };
        _this.receiveMessage = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                try {
                    data = event.data;
                    if (!data || data.from !== 'GAME' || data.to !== 'WRAPPER')
                        return [2];
                    switch (data.action.type) {
                        case 'relaunch': {
                            if (this.props.onRelaunch)
                                this.props.onRelaunch();
                            return [2, console.warn('***** ngl relaunch')];
                        }
                        default:
                            return [2];
                    }
                }
                catch (_b) { }
                return [2];
            });
        }); };
        _this.hideSpinner = function () {
            _this.setState({
                loading: false
            });
        };
        _this.renderIframe = function () {
            var _a;
            var _b = _this.props, classes = _b.classes, game = _b.game, isPBLGame = _b.isPBLGame, gameType = _b.gameType, selectedIndex = _b.selectedIndex, launchToken = _b.launchToken, gameData = _b.gameData;
            var isPortrait = _this.state.isPortrait;
            var url = (game === null || game === void 0 ? void 0 : game.externalLink) ? game === null || game === void 0 ? void 0 : game.externalLink : (_a = gameData === null || gameData === void 0 ? void 0 : gameData.themeHostName) !== null && _a !== void 0 ? _a : '';
            if (!isPBLGame) {
                url = "".concat(game === null || game === void 0 ? void 0 : game.externalLink, "&playMode=").concat(gameType && gameType === 'fun' ? 'demo' : 'money', "&playLevel=1&betLevel=").concat(selectedIndex + 1, "&token=").concat(launchToken);
            }
            if (!isPBLGame || (isPortrait && isPBLGame)) {
                return (React.createElement("iframe", { src: url, id: 'arcade-game-container', className: classes.iframe, onLoad: _this.hideSpinner, title: game === null || game === void 0 ? void 0 : game.name, allow: "autoplay" }));
            }
            else {
                return (React.createElement(Typography_1.default, { variant: 'subtitle1', color: 'error' }, _this.props.t('error.interactiveGame.onlyPortraitMode')));
            }
        };
        _this.state = __assign({}, INITIAL_STATE);
        window.addEventListener('orientationchange', _this.orientationChange);
        return _this;
    }
    ArcadeGame.prototype.componentDidMount = function () {
        if (this.props.isPBLGame) {
            window.addEventListener('message', this.receiveMessagePBL, false);
        }
        else {
            window.addEventListener('message', this.receiveMessage, false);
        }
    };
    ArcadeGame.prototype.componentWillUnmount = function () {
        if (this.props.isPBLGame) {
            window.removeEventListener('message', this.receiveMessagePBL);
        }
        else {
            window.removeEventListener('message', this.receiveMessage);
        }
    };
    ArcadeGame.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(package_1.InformationDialog, { open: this.props.launchGame, hideButton: true, onClose: this.props.onCloseGame, maxWidth: 'lg', noSpaces: true, gameView: true, disableBackdropClick: true },
                this.state.loading ? React.createElement(package_1.AppSpinner, { label: 'Loading Game...' }) : null,
                this.renderIframe())));
    };
    return ArcadeGame;
}(React.Component));
var styles = function (theme) {
    var _a;
    return (0, styles_1.createStyles)({
        iframe: (_a = {
                height: '100%',
                width: '100%',
                maxWidth: '100%'
            },
            _a[theme.breakpoints.down('md')] = {
                height: '100%',
                width: '100%',
                maxWidth: '100%',
                margin: 0,
                maxHeight: '95%',
                position: 'absolute'
            },
            _a)
    });
};
exports.default = (0, react_i18next_1.withTranslation)()((0, styles_1.withTheme)((0, styles_1.withStyles)(styles)(ArcadeGame)));
//# sourceMappingURL=ArcadeGame.js.map